/**
 * @fileoverview Component for displaying an empty list of staff members.
 * This component includes a message and an icon.
 */

import StaffIcon from '../../assets/menu/staff.svg'

/**
 * @function StaffListEmpty
 * @description Component for displaying an empty list of staff members.
 * @returns {JSX.Element} - A React component that renders the empty list of staff members.
 */
export function StaffListEmpty() {
    return (
        <div className="flex flex-col grow justify-center mt-32 px-8 py-8">
            <div className="flex self-center flex-col items-center">
                <div className="flex justify-center items-center w-16 h-16 rounded-full bg-indigo-50 mb-4">
                    <StaffIcon className="w-6 h-6 stroke-indigo-500 stroke-2" />
                </div>
                <h2 className="mb-3 text-gray-900 text-xl font-semibold">No staff to display</h2>
                <p className="text-base text-gray-600 max-w-[486px] text-center">
                    No matching staff or insufficient permissions to view.
                </p>
            </div>
        </div>
    )
}
